<template>
  <div>
    <loadingSkeleton v-if="loading" />
    <div v-if="!loading">
      <a
        v-if="quote"
        v-show="false"
        ref="quoteToggle"
        :href="`#quoteAnchor_${quote}`"
      ></a>
      <h2 class="page-title">
        {{ clientName }}
        <h6 class="project-title-grey">
          {{ hourCountPerStatus(client.id) }}
        </h6>
        <span v-if="client.supportTime" class="time-text">
          <span class="allocated"> Allocated: {{ client.supportTime }} </span>
          <span class="allocated">
            Remaining: {{ getRemainingHours(client) }}
          </span>
          <span> Other: {{ getOtherHours(client) }} </span>
        </span>
      </h2>
      <b-tabs pills>
        <b-tab ref="list-tab" active>
          <template slot="title">
            <i class="i-Pen-4  ul-tab__icon" />
          </template>
          <b-card-text>
            <div class="master-row">
              <b-button
                :variant="`${showShortTermTasks ? '' : 'outline-'}dark btn-sm`"
                @click="toggleShowShortTermTasks"
                >{{ showShortTermTasks ? "Hide" : "Show" }} Long Term
                Tasks</b-button
              >
              <b-button
                class="toggle-button-gap"
                :variant="`${hideCompletedTasks ? 'outline-' : ''}dark btn-sm`"
                @click="toggleHideCompletedTasks"
                >{{ hideCompletedTasks ? "Show" : "Hide" }} Completed
                Tasks</b-button
              >
              <b-button
                class="toggle-button-gap"
                :variant="`${hideHoldTasks ? '' : 'outline-'}dark btn-sm`"
                @click="togglehideHoldTasks"
                >{{ hideHoldTasks ? "Show" : "Hide" }} On Hold Items (<strong>{{
                  onHoldCount
                }}</strong
                >)</b-button
              >
              <b-button
                class="toggle-button-gap"
                :variant="`${collapseAll ? '' : 'outline-'}dark btn-sm`"
                @click="toggleCollapseAll"
                >{{ collapseAll ? "Reveal" : "Collapse" }} All</b-button
              >
              <ShowTimeButton :client-id="client.id" />
            </div>
            <List
              v-for="(list, index) in lists"
              :key="list.id"
              ref="lists"
              v-model="lists[index]"
              :fixed="list.name == 'Tickets'"
              @remove-list="removeList"
              @update-task="updateTask"
              @update-list="updateList"
              @item-moved="onListShuffled"
              @dragging-started="notifyOtherListsOfDragging(true)"
              @dragging-stopped="notifyOtherListsOfDragging(false)"
            />
            <TicketList
              v-show="client.tickets.tasks.length"
              ref="ticketList"
              v-model="client.tickets"
              :fixed="true"
              @update-ticket="updateTicket"
              @update-list="updateList"
              @item-moved="onListShuffled"
              @dragging-started="notifyOtherListsOfDragging(true)"
              @dragging-stopped="notifyOtherListsOfDragging(false)"
            />
            <ApolloMutation
              :mutation="require('@/graphql/Section/AddSection.gql')"
              :variables="{
                client: {
                  id: clientId
                }
              }"
              @done="listAdded"
            >
              <template v-slot="{ mutate }">
                <b-button
                  variant="outline-light m-1 btn-sm"
                  @click="addNewList(mutate)"
                  >Add new list</b-button
                >
              </template>
            </ApolloMutation>
          </b-card-text>
        </b-tab>
        <b-tab>
          <template slot="title">
            <i class="i-Calendar-4  ul-tab__icon" />
          </template>
          <b-card-text>
            <Calendar
              v-model="lists"
              :colour-palette="calendarColourPalette"
              @update-calendar-task="updateCalendarTask"
            />
          </b-card-text>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>
<script>
import List from "@/components/project/projectlist/list"
import TicketList from "@/components/project/projectlist/ticketList"
// import Calendar from "@/components/calendar"
import loadingSkeleton from "@/components/project/loadSkeleton"
import { mapState, mapMutations, mapGetters } from "vuex"
import ShowTimeButton from "@/components/client/showTimeButton"

export default {
  layout: "default",
  name: "Client",
  components: {
    List,
    TicketList,
    Calendar: () => import("@/components/calendar"),
    loadingSkeleton,
    ShowTimeButton
  },
  props: {
    quote: {
      type: String,
      required: false,
      default: null
    }
  },
  apollo: {
    client: {
      query: require("@/graphql/Client/GetClient.gql"),
      subscribeToMore: [
        {
          document: require("@/graphql/Task/TaskAdded.gql"),
          updateQuery(previousResult, { subscriptionData }) {
            if (!this.client) return //client isn't set - don't need subscription
            this.client.sections
              .find(x => x.id == subscriptionData.data.taskAdded.sectionId)
              ?.tasks.push(subscriptionData.data.taskAdded)
          }
        },
        {
          document: require("@/graphql/Task/TaskDeleted.gql"),
          updateQuery(previousResult, { subscriptionData }) {
            if (!this.client) return //client isn't set - don't need subscription
            this.lodash.remove(
              this.client?.sections.find(
                x => x.id == subscriptionData.data.taskDeleted.sectionId
              )?.tasks,
              task => {
                return task.id === subscriptionData.data.taskDeleted.id
              }
            )
            this.$refs.lists
              .find(
                x => x.list.id == subscriptionData.data.taskDeleted.sectionId
              )
              .$forceUpdate()
          }
        },
        {
          document: require("@/graphql/Task/TaskUpdated.gql"),
          updateQuery(previousResult, { subscriptionData }) {
            if (!this.client) return //client isn't set - don't need subscription
            var updateTask = this.client.sections
              .find(x => x.id == subscriptionData.data.taskUpdated.sectionId)
              ?.tasks?.find(x => x.id == subscriptionData.data.taskUpdated.id)
            if (!updateTask)
              //TODO this is a list change
              return
            if (this.Uid == subscriptionData.data.taskUpdated.uid)
              //This is the client who initiated the subscription change
              return
            //Set the old task to the new task and update the list component
            Object.assign(updateTask, subscriptionData.data.taskUpdated)
            this.$refs.lists
              .find(
                x => x.list.id == subscriptionData.data.taskUpdated.sectionId
              )
              .$forceUpdate()
          }
        }
      ],
      variables() {
        return {
          clientId: this.$route.params.clientId
        }
      },
      update(data) {
        this.constrcuting = true
        this.allChildListsCollpased = this.collapseAll
        this.$nextTick(() => {
          this.loading = false
        })
        //Sort sections
        data.client.sections = data.client.sections.sort((a, b) =>
          a.name > b.name || a.name == "Tickets" ? 1 : -1
        )
        //Get users by email and set them for tickets list/section
        data.client?.tickets.tasks?.forEach(task => {
          task.users.forEach(user => {
            Object.assign(user, this.getUserByEmail(user.email))
          })
        })

        //Take user to quote section if they have come here from
        //...Quotes report
        setTimeout(() => {
          this.$nextTick(() => {
            this.$refs.quoteToggle?.click()
          })
        }, 1000)
        return data.client
      },
      fetchPolicy: "no-cache"
    }
  },
  data() {
    return {
      Uid: null,
      projectListsInOrder: null,
      loading: true,
      constrcuting: false,
      visibleListsNumber: NaN,
      updateTimer: null,
      allChildListsCollpased: false,
      taskUpdateTimer: null,
      listUpdateTimer: null
    }
  },
  computed: {
    ...mapGetters({ getUserByEmail: "getUserByEmail" }),
    ...mapState({
      collapseAll: state => state.taskcontrol.collapseAll,
      hideCompletedTasks: state => state.taskcontrol.hideCompletedTasks,
      hideHoldTasks: state => state.taskcontrol.hideHoldTasks,
      showShortTermTasks: state => state.taskcontrol.showShortTermTasks
    }),
    //TODO: Annoying console errors
    clientName() {
      return this.client?.name
    },
    clientId() {
      return this.client?.id
    },
    //TODO: Annoying console errors
    lists() {
      return this.client?.sections
    },
    calendarColourPalette() {
      return null
      //   this.$utils.generateColourPalette(this.client.colour)
    },
    allListsCollapsed() {
      return !this.$refs["lists"].filter(list => {
        return list.visible
      })?.length + !this.$refs["ticketList"].visible
        ? 1
        : 0
    },
    onHoldCount() {
      let onHoldTasks = 0
      let onHoldTickets = 0

      if (this.lists?.some(x => x))
        onHoldTasks = this.lists?.reduce((a, c) => {
          a.total = a.total || 0
          a.total += c.tasks.filter(x => x.status == "On Hold").length
          return { ...a }
        }).total

      if (this.client?.tickets?.tasks?.some(x => x))
        onHoldTickets =
          this.client?.tickets?.tasks?.filter(x => x.status == "On Hold")
            .length ?? 0

      return (onHoldTasks || 0) + (onHoldTickets || 0)
    }
  },
  created() {
    this.Uid = this.uuidv4()
  },
  methods: {
    ...mapMutations({
      toggleHideCompletedTasks: "togglehideCompletedTasks",
      togglehideHoldTasks: "togglehideHoldTasks",
      togglecollapseAll: "togglecollapseAll",
      toggleShowShortTermTasks: "toggleShowShortTermTasks"
    }),

    /**
     *  Creates unique Id
     * @returns {*}
     */
    uuidv4() {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (
          c ^
          (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
        ).toString(16)
      )
    },
    /**
     *
     * @param mutate
     */
    addNewList(mutate) {
      mutate()
      setTimeout(() => {
        this.$nextTick(() => {
          //Focus list title input
          this.$refs.lists[this.$refs.lists.length - 1].$refs.listName.focus()
          this.$refs.lists[this.$refs.lists.length - 1].$refs.listName.select()
        })
      }, 600)
    },
    /**
     *
     * @param list
     */
    removeList(list) {
      //Remove list from client lists
      this.lodash.remove(this.lists, section => {
        return section.id === list.id
      })
      //For some reason it isnt updating automatically so..
      this.$forceUpdate()
    },
    /**
     *
     * @param data
     * @returns {Promise<void>}
     */
    async listAdded({ data }) {
      this.client.sections.push(data.addSection)
    },
    /**
     *
     * @param parameters
     * @returns {Promise<void>}
     */
    async onListShuffled(parameters) {
      var fromList = this.lists.find(list => {
        return list.id == parameters.listFrom
      })
      var toList = this.lists.find(list => {
        return list.id == parameters.listTo
      })
      let task = fromList.tasks.find(x => x.id == parameters.taskId)
      if (toList) {
        //false if deleted
        //Add task to new list
        // toList.tasks.unshift(task)
        task.sectionId = toList.id
      } else {
        //remove task from previous list
        this.lodash.remove(fromList.tasks, task => {
          return task.id === parameters.taskId
        })
        await this.deleteTask({
          description: task.description,
          completed: task.completed,
          hours: task.hours,
          statusId: task.statusId,
          priority: task.priority,
          start: task.start,
          end: task.end,
          id: task.id,
          number: task.number,
          users: task.users.map(x => x.id),
          sectionId: task.sectionId,
          deleted: true
        })
      }

      //Just updating the sectionId for this task
      await this.updateTask({
        description: task.description,
        completed: task.completed,
        hours: task.hours,
        statusId: task.statusId,
        priority: task.priority,
        start: task.start,
        end: task.end,
        id: task.id,
        number: task.number,
        users: task.users?.map(x => x.id),
        sectionId: task.sectionId
      })
    },
    /**
     *
     * @param value
     */
    notifyOtherListsOfDragging(value) {
      this.$refs["lists"].forEach(list => {
        list.onSeperateListDragging(value)
      })
    },

    toggleCompletedTasks() {
      this.hideCompletedTasks = !this.hideCompletedTasks
    },
    toggleCollapseAll() {
      this.togglecollapseAll()
      this.$refs["lists"].forEach(list => {
        list.onCollapse(!this.collapseAll)
      })
      this.$refs["ticketList"].onCollapse(!this.collapseAll)
    },
    /**
     * Gets the remaining Billable hours for client
     * @param client
     * @returns {number}
     */
    getRemainingHours(client) {
      let total = 0
      if (!client.timeLogs?.some(x => x)) total = client.supportTime
      else
        client.timeLogs.forEach(c => {
          total +=
            (c.type === "Billable" || c.type === "Unsure") && c.support
              ? c.time
              : 0 || 0
        })
      total = client.supportTime - total
      total = parseFloat(total.toFixed(2))
      client.remaining = total
      return total
    },
    /**
     * Gets Non-Billable/Non-Support hours logged for client
     * @param client
     * @returns {number}
     */
    getOtherHours(client) {
      let total = 0
      if (!client.timeLogs?.some(x => x)) return total
      else
        client.timeLogs.forEach(c => {
          total += (!c.support ? c.time : 0) || 0
        })

      return parseFloat(total.toFixed(2))
    },
    /**
     *
     * @param list
     * @returns {Promise<void>}
     */
    async updateList(list) {
      await this.$apollo.mutate({
        mutation: require("@/graphql/Section/UpdateSection.gql"),
        variables: {
          section: list
        }
      })
    },
    /**
     *
     * @param task
     * @returns {Promise<void>}
     */
    async updateCalendarTask(task) {
      Object.assign(
        this.lists
          .find(x => x.id == task.sectionId)
          ?.tasks.find(x => x.id == task.id),
        task
      )
      await this.updateTask({
        description: task.description,
        completed: task.completed,
        hours: task.hours,
        statusId: task.statusId,
        priority: task.priority,
        start: this.$utils.getDate(task.start),
        end: this.$utils.getDate(task.end),
        id: task.id,
        number: task.number,
        users: task.users.map(x => x.id),
        sectionId: task.sectionId
      })
    },
    /**
     *
     * @param task
     * @returns {Promise<void>}
     */
    async updateTask(task) {
      await this.$apollo.mutate({
        mutation: require("@/graphql/Task/UpdateTask.gql"),
        variables: {
          task: task
        }
      })
    },
    /**
     *
     * @param ticket
     * @returns {Promise<void>}
     */
    async updateTicket(ticket) {
      await this.$apollo.mutate({
        mutation: require("@/graphql/Ticket/UpdateTicket.gql"),
        variables: {
          ticket: ticket
        }
      })
    },
    /**
     * Deletes task
     * @param task
     * @returns {Promise<void>}
     */
    async deleteTask(task) {
      await this.$apollo.mutate({
        mutation: require("@/graphql/Task/DeleteTask.gql"),
        variables: {
          task: task
        }
      })
    },
    allClientTasks() {
      return (
        [].concat(
          ...[]
            .concat(...this.client?.sections)
            ?.map(x => x?.tasks.filter(x => !x.completed))
        ) ?? []
      )
    },
    allClientTickets() {
      return (
        [].concat(...this.client?.tickets?.tasks?.filter(x => !x?.completed)) ??
        []
      )
    },
    hourCountPerStatus() {
      const tmpTickets = this.allClientTickets()
      const tmpTasks = this.allClientTasks()

      const onHoldHoursTaskCnt = this.totalTaskHours(tmpTasks, "On Hold")

      const onHoldHoursTickCnt = this.totalTicketHours(tmpTickets, "On Hold")

      const waitingOnClientHoursTaskCnt = this.totalTaskHours(
        tmpTasks,
        "Waiting On Client"
      )

      const waitingOnClientHoursTickCnt = this.totalTicketHours(
        tmpTickets,
        "Waiting On Client"
      )

      const pendingReleaseHoursTaskCnt = this.totalTaskHours(
        tmpTasks,
        "Pending Release"
      )
      const pendingReleaseHoursTickCnt = this.totalTicketHours(
        tmpTickets,
        "Pending Release"
      )

      const needsSchedulingHoursTaskCnt = this.totalTaskHours(
        tmpTasks,
        "Needs Scheduling"
      )
      const needsSchedulingHoursTickCnt = this.totalTicketHours(
        tmpTickets,
        "Needs Scheduling"
      )

      const scheduledHoursTaskCnt = this.totalTaskHours(tmpTasks, "Scheduled")

      const scheduledHoursTickCnt = this.totalTicketHours(
        tmpTickets,
        "Scheduled"
      )

      const status =
        " - On Hold: " +
        (onHoldHoursTaskCnt + onHoldHoursTickCnt) +
        " • Waiting On Client: " +
        (waitingOnClientHoursTaskCnt + waitingOnClientHoursTickCnt) +
        " • Pending Release: " +
        (pendingReleaseHoursTaskCnt + pendingReleaseHoursTickCnt) +
        " • Needs Scheduling: " +
        (needsSchedulingHoursTaskCnt + needsSchedulingHoursTickCnt) +
        " • Scheduled: " +
        (scheduledHoursTaskCnt + scheduledHoursTickCnt)

      return status
    },
    totalTicketHours(ticketList, statusName) {
      var toReduce =
        ticketList
          ?.filter(x => x?.hours && x?.status == statusName)
          ?.map(x => x?.hours) ?? []
      if (!toReduce.length || toReduce.length <= 0) return 0
      //Reduce new array of all task hours
      let totalHours =
        (toReduce?.reduce(
          (accumulator, currentValue) =>
            parseFloat(accumulator) + parseFloat(currentValue)
        ) ??
          0) ||
        0

      if (!totalHours) return 0

      //Issue where value is a string when total hours is initially 0
      if (typeof totalHours == "string") totalHours = Number(totalHours)

      let final = totalHours

      if (final == "0.00") return 0

      return final
    },
    totalTaskHours(taskList, statusName) {
      const incompleteTasks =
        taskList?.filter(x => x?.hours && x?.status == statusName) ?? []
      if (!incompleteTasks.length || incompleteTasks.length <= 0) {
        return 0
      }
      //Reduce new array of all task hours
      let totalHours =
        (incompleteTasks
          .map(x => x?.hours)
          ?.reduce(
            (accumulator, currentValue) =>
              parseFloat(accumulator) + parseFloat(currentValue)
          ) ??
          0) ||
        0
      if (!totalHours) return 0

      //Issue where value is a string when total hours is initially 0
      if (typeof totalHours == "string") totalHours = Number(totalHours)

      let final = totalHours

      if (final == "0.00") return 0

      return final
    }
  }
}
</script>
<style scoped>
.grid-square {
  display: inline-block;
  padding: 15px;
  margin: 5px;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 4px;
}
h2 > button {
  float: right;
}
.master-row {
  border-radius: 4px;
  margin-bottom: 5px;
}

.master-row > button:not(:first-child) {
  margin-left: 0.25rem;
}

.time-text {
  font: icon;
  margin-left: 1rem;
}

.allocated {
  margin-right: 1rem;
}

.project-title-grey {
  display: inline-block;
  margin-left: 10px;
  color: rgb(186, 186, 186);
}
</style>
